import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Select from 'react-select-legacy'
import './MultiSelect.scss'

class SelectField extends Component {
  static defaultProps = {
    meta: {},
    input: {},
    labelKey: 'name',
    valueKey: 'id',
    options: [],
    multi: false,
  }

  static propTypes = {
    options: PropTypes.array,
  }

  defaults = {
    input: {
      value: 'uncontroled',
      onChange: () => console.error('uncontrolled'),
      onBlur: () => null,
      onFocus: () => null,
    },
    meta: {
      touched: false,
      error: false,
    },
  }

  onMultiChange = (values) => {
    const { valueKey } = this.props

    if (values.map((v) => v[valueKey]).includes('all')) {
      return this.props.input.onChange(this.props.options)
    }

    return this.props.input.onChange(values)
  }

  render() {
    const { label, options, t, className, ...props } = this.props
    const meta = { ...this.defaults.meta, ...this.props.meta }
    const input = { ...this.defaults.input, ...this.props.input }

    return (
      <div className={`md-select-basic md-field ${className}`}>
        {label && <label>{label}</label>}

        <div className={'md-multi-select'}>
          {this.props.multi ? (
            <Select
              {...props}
              value={input.value}
              onChange={this.onMultiChange}
              onFocus={() => input.onFocus()}
              onBlur={() => input.onBlur()}
              simpleValue={false}
              closeOnSelect={false}
              removeSelected={false}
              options={[{ [this.props.valueKey]: 'all', [this.props.labelKey]: t('Todos') }, ...options]}
            />
          ) : (
            <Select
              {...props}
              value={input.value}
              onChange={input.onChange}
              onFocus={() => input.onFocus()}
              onBlur={() => input.onBlur()}
              options={options}
            />
          )}
        </div>
        {meta.touched && meta.error && <span className="error">{meta.error}</span>}
      </div>
    )
  }
}

export default withTranslation()(SelectField)
